class CustomerAddresses {
  constructor() {
    this.selectors = {
      customerAddresses: '[data-customer-addresses]',
      addressCountrySelect: '[data-address-country-select]',
      toggleAddressButton: '[data-toggle-target]',
      deleteAddressButton: 'button[data-confirm-message]',
    };
    this.attributes = {
      confirmMessage: 'data-confirm-message',
    };
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(this.selectors.customerAddresses);
    return container
      ? {
        container,
        addressContainer: container.querySelector(this.selectors.addressContainer),
        toggleButtons: document.querySelectorAll(this.selectors.toggleAddressButton),
        deleteButtons: container.querySelectorAll(this.selectors.deleteAddressButton),
        countrySelects: container.querySelectorAll(this.selectors.addressCountrySelect),
      }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', (e) => {
        const { currentTarget } = e;
        const toggleTarget = document.getElementById(`${currentTarget.dataset.toggleTarget}`);
        toggleTarget.classList.toggle('hidden');
        // toggleTarget.classList.toggle('active');
      });
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(this.attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}
/**
 * Custom JS for Hyper Reedstead theme
 */

document.addEventListener('DOMContentLoaded', () => {
  // Delegate click event for the "SEE FULL DIMENSIONS" button
  document.addEventListener('click', (event) => {
    const target = event.target.closest('.product__dimension-btn');
    if (target) {
      event.preventDefault();

      // Find the collapsible tab with data-heading containing "dimensions"
      // Note: lowercase check as per the snippet's data-heading generation
      const dimensionTab = document.querySelector('[data-heading*="dimensions"]');

      if (dimensionTab) {
        // Open the accordion
        dimensionTab.open = true;
        dimensionTab.setAttribute('aria-expanded', 'true');

        // iOS Compatibility: Delay scroll to ensure layout has updated after opening accordion
        setTimeout(() => {
          const header = document.querySelector('.header-section');
          const headerHeight = header ? header.offsetHeight : 0;
          const topOffset = headerHeight + 50; // Add 50px extra padding to ensure the title is well visible

          // Get the absolute top position of the dimension tab
          const elementRect = dimensionTab.getBoundingClientRect();
          const targetTop = elementRect.top + window.scrollY - topOffset;

          window.scrollTo({
            top: targetTop,
            behavior: 'smooth'
          });
        }, 100);
      }
    }
  });

  // Mobile search icon toggle
  document.querySelectorAll('.mobile-search-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const header = btn.closest('header');
      const searchBar = header?.querySelector('.header__search');
      if (searchBar) {
        const isOpen = searchBar.classList.toggle('mobile-search-open');
        if (isOpen) {
          const input = searchBar.querySelector('input[type="search"]');
          input?.focus();
        }
      }
    });
  });

  // Close mobile search when the existing close button is clicked
  document.querySelectorAll('.header__search-close').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const searchBar = closeBtn.closest('.header__search');
      searchBar?.classList.remove('mobile-search-open');
    });
  });

  // Close mobile search when overlay is clicked
  document.querySelectorAll('.fixed-overlay--header-section').forEach(overlay => {
    overlay.addEventListener('click', () => {
      document.querySelectorAll('.header__search.mobile-search-open').forEach(el => {
        el.classList.remove('mobile-search-open');
      });
    });
  });

  // Inject SVG arrow after Judge.me review badge
  const injectReviewBadgeArrow = () => {
    document.querySelectorAll('.jdgm-prev-badge:not([data-arrow-added])').forEach(badge => {
      const svg = `
        <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="jdgm-custom-arrow">
          <path d="M7.5 3.75L13.75 10L7.5 16.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;
      badge.insertAdjacentHTML('beforeend', svg);
      badge.dataset.arrowAdded = 'true';
    });
  };

  const reviewBadgeObserver = new MutationObserver(injectReviewBadgeArrow);
  reviewBadgeObserver.observe(document.body, { childList: true, subtree: true });
  injectReviewBadgeArrow();

  // Disable Judge.me smooth scroll — jump directly to #judgeme_product_reviews
  document.addEventListener('click', (e) => {
    const badgeText = e.target.closest('.jdgm-prev-badge');
    if (!badgeText) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const target = document.getElementById('judgeme_product_reviews');
    if (target) {
      target.scrollIntoView({ behavior: 'instant' });
    }
  }, true);

  // Add click listener for account link to open subscription modal
  document.addEventListener('click', (event) => {
    let accountLink;
    if (event.target && event.target.closest) {
      accountLink = event.target.closest('[title="https://account.reedstead.com/"]');
    }
    if (accountLink) {
      event.preventDefault();
      const modal = document.getElementById('SubscriptionModal');
      if (modal) {
        modal.show(accountLink);
      }
    }
  });

  /* customToggleVariant callback */
  // 每个 SKU 一个独立的 media-gallery 容器，或者共用一个 default 容器
  // scope: 限定查找范围的根节点，默认 document（详情页）；quick-view 场景下传入弹窗容器节点
  function toggleCombinationImg(variantOrId, scope) {
    scope = scope || document;

    // 如果没有开启变体组合图功能（即只渲染了一个默认图库），则跳过执行
    const allGalleries = scope.querySelectorAll('media-gallery.variant-gallery');
    if (allGalleries.length <= 1) return;

    try {
      let id, variant;
      if (typeof variantOrId === 'object' && variantOrId !== null) {
        variant = variantOrId;
        id = String(variant.id);
      } else {
        id = String(variantOrId);
        variant = null;
      }

      let activeGallery = null;

      // 1. 优先寻找对应变体 ID 的专属 Gallery
      const exactGallery = scope.querySelector(`media-gallery.variant-gallery[data-variant-id="${id}"]`);

      if (exactGallery) {
        activeGallery = exactGallery;
      } else {
        // 2. 如果没找到，则寻找标记为默认的共享 Gallery
        activeGallery = scope.querySelector('media-gallery.variant-gallery[data-is-default="true"]');
      }

      allGalleries.forEach(gallery => {
        if (gallery === activeGallery) {
          gallery.style.display = '';
        } else {
          gallery.style.display = 'none';
        }
      });

      // 从 display:none 切回来后，Swiper 需要重新计算尺寸
      if (activeGallery) {
        const isQuickView = scope !== document;
        // 被 display:none 隐藏的 gallery 无法触发 IntersectionObserver，
        // 因此 init() 从未被调用。切换显示后需要主动补充初始化。
        if (typeof activeGallery.init === 'function' && !activeGallery.isInitialized) {
          activeGallery.init();
        }
        setTimeout(() => {
          const mainSwiper = activeGallery.sliderInstance?.slider;
          const thumbsSwiper = activeGallery.thumbsInstance?.slider;

          // 3. 确定当前变体应该显示的封面图 ID
          let featuredMediaId = (variant && variant.featured_media) ? String(variant.featured_media.id) : activeGallery.dataset.featuredMediaId;

          let targetIndex = 0;

          if (featuredMediaId && mainSwiper) {
            mainSwiper.slides.forEach(slide => {
              if (
                !slide.classList.contains('swiper-slide-duplicate') &&
                slide.dataset.mediaId === featuredMediaId
              ) {
                targetIndex = parseInt(slide.dataset.swiperSlideIndex ?? 0);
              }
            });
          }

          if (mainSwiper) {
            mainSwiper.update();
            // quick-view 内始终跳转到对应封面；详情页仅在有 variant URL 参数时跳转
            if (isQuickView || location.href.includes('variant')) {
              mainSwiper.slideToLoop(targetIndex, 0);
            }
          }
          if (thumbsSwiper) {
            thumbsSwiper.update();
            if (isQuickView || location.href.includes('variant')) {
              thumbsSwiper.slideToLoop(targetIndex, 0);
            }
          }

          // 执行并清除 preset 组合图回调（由 product-group-buy.js 注册）
          if (!isQuickView && typeof window._presetGalleryOverlayCallback === 'function') {
            window._presetGalleryOverlayCallback();
            window._presetGalleryOverlayCallback = null;
          }
        }, 50);
      }
    } catch (e) {
      console.error(e);
    }
  }

  const updateBreadcrumbSku = (variantOrId) => {
    if (variantOrId && typeof variantOrId === 'object' && typeof variantOrId.sku !== 'undefined') {
      const breadcrumbSku = document.getElementById('breadcrumb-product-sku');
      const breadcrumbSep = document.getElementById('breadcrumb-sku-sep');
      if (breadcrumbSku && breadcrumbSep) {
        if (variantOrId.sku) {
          breadcrumbSku.textContent = variantOrId.sku;
          breadcrumbSku.style.display = '';
          breadcrumbSep.style.display = '';
        } else {
          breadcrumbSku.style.display = 'none';
          breadcrumbSep.style.display = 'none';
        }
      }
    }
  };

  window.customToggleVariant = function (variantOrId) {
    // 检测调用是否来自 quick-view 弹窗（弹窗可见时，限定 scope 在弹窗内）
    const quickViewContent = document.querySelector('quick-view-modal:not([hidden]) .quick-view__content');
    toggleCombinationImg(variantOrId, quickViewContent || document);
    updateVisibility(variantOrId);
    updateBreadcrumbSku(variantOrId);
    
    // 派发全局变体切换事件，供其他独立组件（如 group-buy-form）监听
    document.dispatchEvent(new CustomEvent('variant:custom-change', { detail: { variantOrId } }));
  };

  // 页面加载时激活默认变体对应的 gallery
  const selectedVariantEle = document.querySelector('[data-selected-variant-id]');
  if (selectedVariantEle) {
    let variantPayload = null;
    try {
      const variantScript = document.querySelector('variant-selects [data-selected-variant]');
      if (variantScript) {
        variantPayload = JSON.parse(variantScript.textContent.trim());
      }
    } catch (e) {
      // 解析失败则 fallback 到 ID
      console.error(e);
    }
    toggleCombinationImg(variantPayload || selectedVariantEle.getAttribute('data-selected-variant-id'));
  }

  // 切换库存提示
  const updateVisibility = (variantOrId = {}) => {
    const variantId = variantOrId.id || '0';
    const overselling = document.querySelector(
      `.product__delivery-estimation-overselling`
    );
    const normal = document.querySelector(`.product__delivery-estimation`);

    if (!overselling || !normal) return;

    const extraStockIds = (overselling.getAttribute('data-sku-extra-stock') || '').split(',');

    if (extraStockIds.includes(variantId.toString())) {
      overselling.classList.remove('hidden');
      normal.classList.add('hidden');

      // 更新文案
      const tipsInput = document.querySelector(`input[name="sku_extra_shipping_tips_${variantId}"]`);
      const heading = overselling.querySelector('.heading');
      if (tipsInput && heading) {
        heading.innerText = tipsInput.value;
      }
    } else {
      overselling.classList.add('hidden');
      normal.classList.remove('hidden');
    }
  };
});
